export default "__VITE_ASSET__D6wJ4IkH__"